import { useState, useEffect, useRef } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL;
const CENTRAL_ADMIN_APP = process.env.REACT_APP_CENTRAL_ADMIN_URL;
const PATIENT_APP = process.env.REACT_APP_PATIENT_URL;
export const useProviderList = (setProfileObject) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [inputFocused, setInputFocused] = useState(false);
  const [providers, setProviders] = useState([]);
  const[loading,setLoaidng] = useState(false);
  const dropdownRef = useRef(null);

  // Fetch providers based on search term
  const getTenants = async () => {
    setLoaidng(true)
    try {
      const response = await axios.get(`${ACCOUNTS_URL}/tenants?status=active&search=${searchTerm}`);
      setProviders(response.data?.data?.data || []);
    } catch (error) {
      toast.error(error.response?.data?.error?.message || "Failed to fetch providers.");
    } finally{
      setLoaidng(false)
    }
  };
 

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getTenants();
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Handle Provider Selection
  const handleProviderSelect = (provider) => {
    const legalName = provider?.businessInformation?.legalName || "Unknown";
    const city = provider?.businessInformation?.city || "Unknown Location";

    setSearchTerm(legalName);
    setProfileObject((prev) => ({
      ...prev,
      tenantId: provider?._id,
      tenantName: legalName,
    }));
    toast.success(`You selected ${legalName} located in ${city}.`);
    setInputFocused(false);
  };

  // Handle Input Blur
  const handleBlur = (e) => {
    if (dropdownRef.current?.contains(e.relatedTarget)) return;
    setTimeout(() => setInputFocused(false), 100);
  };

  const createLastAppLogin = async (response) => {
    const { userId, tenantId, access_token, userType } = response;
    try {
      await axios.post(`${ACCOUNTS_URL}/lastapp`, {userId,tenantId,appName: userType});

      const targetUrl =
        userType === "central_admin"
          ? `${CENTRAL_ADMIN_APP}?vt=${access_token}&ui=${userId}&ti=${tenantId}`
          : `${PATIENT_APP}?vt=${access_token}&ui=${userId}&ti=${tenantId}`;

      window.location.href = targetUrl; 
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
     
    }
  };

   
  const handleProviderSubmit = async (profileObject) => {
    try {
      const { setupToken, ...body } = profileObject;
      if (!setupToken) {
        toast.error("Please sign in again to continue.");
        return;
      }
      const response = await axios.post(`${ACCOUNTS_URL}/auth/patient-profile`, body, { headers: { Authorization: `Bearer ${setupToken}` } });

      if (response.data.data && response.data.data.access_token) {
        createLastAppLogin(response.data.data);
      } else {
        toast.error("Failed to authenticate user.");
      }
    } catch (error) {
      toast.error(error.response?.data?.error?.message || "An error occurred.please try again");
    }
  };


  return {
    searchTerm,
    setSearchTerm,
    providers,
    inputFocused,
    setInputFocused,
    dropdownRef,
    handleProviderSelect,
    handleBlur,
    getTenants,
    handleProviderSubmit,
    createLastAppLogin,
    loading
  };
};
